import { Caption, Card, Grid, Heading } from '@design-systems/canvas-ui'
import { CardIcon } from '@plm-core/utils'

interface AccountCardProps {
  svg: any
  cardHeading: string
  cardSubheading: string
  children: React.ReactNode
}

export const AccountCard = ({
  svg,
  cardHeading,
  cardSubheading,
  children,
}: AccountCardProps) => {
  return (
    <Card className="hc8-pa-6x">
      <Grid.Container align="center">
        <Grid.Item>
          <CardIcon svg={svg} size="lg" />
        </Grid.Item>
        <Grid.Item size={{ xs: true }}>
          <Caption below={cardSubheading}>
            <Heading size={5}>{cardHeading}</Heading>
          </Caption>
        </Grid.Item>
        <Grid.Item size={{ xs: 12 }}>{children}</Grid.Item>
      </Grid.Container>
    </Card>
  )
}

export default AccountCard
